import React from 'react'
import classes from './styles.module.scss'
// import { FormattedMessage } from 'react-intl'
// import messages from './messages'
import { Flex } from 'antd-mobile'
import _ from 'lodash'
import { Modal } from 'antd'
import { devicePay } from 'utils'
import DevicePay from 'components/PaymentMethods/DevicePay'
import WhiteSpace from 'components/WhiteSpace'
import WingBlank from 'components/WingBlank'
import PaymentMethodIcon from 'components/PaymentMethodIcon'

export default class PaymentMethodSwitcher extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      index: 0,
      data: [],
      visible: false,
    }
  }

  handleClick = (item, prevIndex) => {
    const index = _.findIndex(this.state.origin, item)
    this.props.onSelect(`${index}`)
    this.setState({
      index: prevIndex,
    })
  }

  handleModalSelect = (item) => {
    const index = _.findIndex(this.state.origin, item)
    this.props.onSelect(`${index}`)
    const data = _.chain(this.state.data)
      .clone()
      .pull(item)
      .unshift(item)
      .value()
    this.setState({
      visible: false,
      index: 0,
      data,
    })
  }

  componentDidMount = async () => {
    this.processData()
  }

  componentDidUpdate = async (prevProps) => {
    // Re-process when data prop changes (e.g., when filtered data arrives)
    if (!_.isEqual(this.props.data, prevProps.data)) {
      this.processData()
    }
  }

  processData = async () => {
    if (this.props.data && !_.isEqual(this.state.data, this.props.data)) {
      // If skipFilter is true, data is already filtered by parent (PayPage)
      const data = this.props.skipFilter
        ? _.clone(this.props.data)
        : await devicePay.filter(_.clone(this.props.data))
      let preferred = null
      // Only extract preferred device pay if not keeping it in tabs (for iframe mode)
      if (!this.props.keepPreferredInTabs) {
        preferred = _.find(data, devicePay.preferred())
        preferred && _.remove(data, preferred)
      }
      this.setState({
        origin: data,
        data,
        preferred,
      })
    }
  }

  render() {
    const { data, visible, preferred } = this.state

    if (data.length < 2) {
      // 只有一种支付方式的时候，不显示选择栏
      return <></>
    }

    const chunkArray = _.chunk(data, 3)

    return (
      <React.Fragment>
        {preferred && (
          <WingBlank>
            <DevicePay
              actions={this.props.actions}
              item={preferred}
              siteConfig={this.props.siteConfig}
              submit={this.props.submit}
            />
            <WhiteSpace size='xl' />
          </WingBlank>
        )}
        <Flex
          align='stretch'
          className={classes.componentsPaymentMethodSwitcher}
        >
          {chunkArray[0].map((item, index) => {
            var className = classes.payTab
            this.state.index === index && (className += ' ' + classes.active)
            return (
              <Flex.Item
                key={index}
                className={className}
                onClick={() => this.handleClick(item, index)}
              >
                <Flex
                  direction='column'
                  justify='center'
                  align='start'
                  style={{ height: '100%' }}
                >
                  <PaymentMethodIcon height={24} {...item} />
                  <div className={classes.name}>
                    <b>{item.tabName}</b>
                  </div>
                </Flex>
              </Flex.Item>
            )
          })}
          {chunkArray[1] && (
            <div className={classes.menu}>
              <Flex
                direction='column'
                justify='around'
                style={{ height: '100%' }}
                onClick={() => this.setState({ visible: true })}
              >
                {chunkArray[1].map((item, index) => (
                  <PaymentMethodIcon key={index} width={30} {...item} />
                ))}
              </Flex>
              <span>
                <b className='iconfont iconarrow-right-small text-main' />
              </span>
              <Modal
                centered
                visible={visible}
                closable={false}
                footer={null}
                onCancel={() => this.setState({ visible: false })}
                wrapClassName={classes.modal}
              >
                {visible &&
                  _.drop(data, 3).map((item, index) => (
                    <Flex
                      key={index}
                      onClick={() => this.handleModalSelect(item)}
                    >
                      <PaymentMethodIcon height={24} {...item} />
                      <Flex.Item className='text-left'>
                        <b>{item.tabName}</b>
                      </Flex.Item>
                    </Flex>
                  ))}
              </Modal>
            </div>
          )}
        </Flex>
      </React.Fragment>
    )
  }
}
